import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AvatarTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('avatar');

  const tabs = [
    { id: 'trains', label: t('avatar:tabs.trains'), path: '/avatar-training' },
    { id: 'videos', label: t('avatar:tabs.videos'), path: '/avatar-video' },
  ];

  const activeTab = location.pathname === '/avatar-video' ? 'videos' : 'trains';

  return (
    <div className="p-4 border-b border-border-subtle">
      <nav className="flex space-x-8">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`py-1 px-1 border-b-2 font-medium text-lg transition-colors cursor-pointer ${activeTab === tab.id
                ? 'border-primary text-gray-50'
                : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-300'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
